/* tslint:disable */
/* eslint-disable */
/**
 * LMS API
 * This is LMS API Documentation.
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { MaskedSubscriptionItem } from './masked-subscription-item';
import { User } from './user';

/**
 * 
 * @export
 * @interface MaskedSubscription
 */
export interface MaskedSubscription {
    /**
     * 
     * @type {number}
     * @memberof MaskedSubscription
     */
    id: number;
    /**
     * 
     * @type {User}
     * @memberof MaskedSubscription
     */
    user: User;
    /**
     * 
     * @type {Array<MaskedSubscriptionItem>}
     * @memberof MaskedSubscription
     */
    subscriptionItems: Array<MaskedSubscriptionItem>;
    /**
     * 
     * @type {string}
     * @memberof MaskedSubscription
     */
    startDate: string;
    /**
     * 
     * @type {string}
     * @memberof MaskedSubscription
     */
    endDate: string;
    /**
     * サブスクリプションの状態 0: incomplete / 初回決済失敗 1: incomplete_expired / 初回決済失敗(期限切れ) 2: trialing / トライアル中 3: active / 現在契約 4: past_due / 自動契約更新失敗 5: canceled / キャンセル済 6: unpaid / 未払い 
     * @type {number}
     * @memberof MaskedSubscription
     */
    phase: MaskedSubscriptionPhaseEnum;
    /**
     * 期末の更新有無 0: 更新無し（キャンセル） 1: 更新有り 
     * @type {number}
     * @memberof MaskedSubscription
     */
    cancelAtPeriodEnd: number;
    /**
     * 有効/無効 0: 無効 1: 有効 
     * @type {number}
     * @memberof MaskedSubscription
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof MaskedSubscription
     */
    contractStartDate: string;
    /**
     * 
     * @type {string}
     * @memberof MaskedSubscription
     */
    contractEndDate: string;
    /**
     * 
     * @type {string}
     * @memberof MaskedSubscription
     */
    cancellationStartDate: string;
    /**
     * 
     * @type {string}
     * @memberof MaskedSubscription
     */
    cancellationEndDate: string;
    /**
     * 
     * @type {boolean}
     * @memberof MaskedSubscription
     */
    isCancelable: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MaskedSubscription
     */
    isPremium: boolean;
    /**
     * 
     * @type {string}
     * @memberof MaskedSubscription
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof MaskedSubscription
     */
    updatedAt?: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum MaskedSubscriptionPhaseEnum {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_4 = 4,
    NUMBER_5 = 5,
    NUMBER_6 = 6
}



